import config from './config'

export const NetworkAPI = {
    getAccounts: () => {
        return config.get('/api/network/accounts/')
    },

    connectAccount: (payload) => {
        return config.post('/api/network/oauth/', payload)
    },

    deleteAccount: (id) => {
        return config.delete(`/api/network/accounts/${id}`)
    },
}
